
export const ACTIONS = {
  REMOVE_DISCOVERY: 'discovery/REMOVE_DISCOVERY',
}

export default ACTIONS;
